import React, { useState, useEffect, useMemo } from "react";
import {
    Col,
    Container,
    Row,
    Table,
    Modal,
    Tab,
    Nav,
    Form,
} from "react-bootstrap";
import Header from "../../Component/Header";
import SearchableDropdown from "../../Component/SearchableDropdown";
import downIconWeb from "../../Asset/Images/down-arrow-white.svg";
import { ToastContainer, toast } from "react-toastify";
import MobileFooter from "../../Component/MobileFooter";



import { getUsers, getRoles, assignRole, addFacility, deleteFacility } from "../../Services/user";
import { getLocations } from "../../Services/deploy";


import deleteIcon from "../../Asset/Images/delete-icon-web.svg";
import deleteIconModal from "../../Asset/Images/delete-icon-modal.svg";
import crossIconRoll from "../../Asset/Images/cross-icon-circle.svg";



function Users() {


    const [showRole, setShowRole] = useState(false);
    const [showFacility, setShowFacility] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [facilityLoading, setFacilityLoading] = useState(false);
    const [roleLoading, setRoleLoading] = useState(false);
    const [facilityKey, setFacilityKey] = useState('');
    const [roleKey, setRoleKey] = useState('');

    const [userList, setUserList] = useState([]);
    const handleShowFacility = () => setShowFacility(true);
    const [inputOptionList, setInputOptionList] = useState([
        {
            label: 'Facility 1',
            value: 'Facility 1'
        },
        {
            label: 'Facility 2',
            value: 'Facility 2'
        },
        {
            label: 'Facility 3',
            value: 'Facility 3'
        }
    ]);
    const [RoleList, setRoleList] = useState([]);
    const [emailList, setEmailList] = useState([]);
    const [facilityList, setFacilityList] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedFacility, setSelectedFacility] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState({});
    const [facilityError, setFacilityError] = useState({});
    const [showDelete, setShowDelete] = useState(false);
    const [showRoleDelete, setShowRoleDelete] = useState(false);
    const [additionalEmail, setAdditionalEmail] = useState([]);
    const [additionalEmailError, setAdditionalEmailError] = useState("");
    const [additionalEmails, setAdditionalEmails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15
    const totalPages = Math.ceil(userList.length / itemsPerPage);
    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return userList.slice(startIndex, endIndex);
    }, [userList, currentPage]);



    useEffect(() => {
        fetchUsers();
        fetchRoles()
        fetchFacility()
    }, []);

    const handleCloseDelete = () => {
        setShowDelete(false);
        setFacilityKey('')
    }

    const handleCloseRoleDelete = () => {
        setShowRoleDelete(false);
        setRoleKey('')
    }

    const handleShowDelete = (val) => {
        setFacilityKey(val)
        setShowDelete(true);
    }

    const handleShowRoleDelete = (val) => {
        setShowRoleDelete(true)
        setRoleKey(val)
    }

    const handleShowRole = () => {
        setShowRole(true)
    }


    let fetchUsers = async () => {
        setIsLoading(true)
        let res = await getUsers(localStorage.access_token);
        setIsLoading(false)
        if (res.data && res.data.data) {

            let filteredData = res.data.data.map(item => ({
                label: item.email,
                value: item.email
            }));
            setEmailList(filteredData)
            setUserList(res.data.data)
        }
    };

    let fetchFacility = async () => {
        setIsLoading(true)
        let locationRes = await getLocations(localStorage.access_token);
        setIsLoading(false)
        if (locationRes && locationRes.data) {
            setFacilityList(locationRes.data.response_body)
        }
    };

    let fetchRoles = async () => {
        let res = await getRoles(localStorage.access_token);
        if (res.data && res.data.data) {
            setRoleList(res.data.data)
        }
    };


    const handleCloseRole = () => {
        setShowRole(false);
        setError({})
        setEmail('')
        setSelectedRole('')
    }
    const handleCloseFacility = () => {
        setShowFacility(false);
        setFacilityError({})
        setSelectedFacility('')
    }
    let handleInputSelect = (e, name) => {
        if (name == 'role') {
            setSelectedRole(e)
            setError({})
        }
        else if (name == 'email') {
            setEmail(e)
            setError({})
        }

    }

    let handleFcilityChange = (e) => {
        setSelectedFacility(e.target.value)
        setFacilityError({})
    }

    let handleRoleSubmit = async (e) => {
        e.preventDefault()
        if (!selectedRole) {
            setError({ role: 'Role is required' })
        } else if (!email) {
            setError({ email: 'Email is required' })
        } else {
            let payload = {
                role: selectedRole,
                email: email
            }
            setError({})
            setRoleLoading(true)
            let assign = await assignRole(payload, localStorage.access_token)
            setRoleLoading(false)
            handleCloseRole()
            if (assign.data && assign.data.status_code == 200) {
                toast.success(assign.data.message)
                fetchUsers()
            } else {
                toast.error(assign.data.message)
            }

        }
    }

    let handleFacilitySubmit = async (e) => {
        e.preventDefault()
        if (!selectedFacility) {
            setFacilityError({ error: 'Facility is required' })
        }
        else {
            setFacilityLoading(true)
            console.log(" localStorage.access_token", localStorage.access_token)
            let res = await addFacility(selectedFacility, localStorage.access_token)
            setFacilityLoading(false)
            setFacilityError({})
            if (res.data && res.data.status_code == 200) {
                toast.success(res.data.message)
                fetchFacility()
                handleCloseFacility()
            } else {
                toast.error(res.data.message)
                handleCloseFacility()
            }
        }
    }

    let handleDeleteFacility = async () => {
        setFacilityLoading(true)
        let res = await deleteFacility(facilityKey, localStorage.access_token)
        if (res.data && res.data.status_code == 200) {
            toast.success(res.data.message)
            fetchFacility()
            handleCloseDelete()

        } else {
            toast.error(res.data.message)
            handleCloseDelete()
        }
        setFacilityLoading(false)
    }

    let handleDeleteRole = async () => {
        setRoleLoading(true)
        let payload = {
            role: '',
            email: roleKey
        }
        let res = await assignRole(payload, localStorage.access_token)
        if (res.data && res.data.status_code == 200) {
            toast.success('Role removed successfully !')
            fetchUsers()
            handleCloseRoleDelete()
        } else {
            toast.error(res.data.message)
            handleCloseRoleDelete()
        }
        setRoleLoading(false)
        setRoleKey('')
    }

    let validateEmail = (email) => {
        if (!email) {
            return false
        }
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            return false
        } else {
            return true
        }
    }

    let handleAddEmail = () => {
        let check = validateEmail(additionalEmail)
        if (!check) {
            setAdditionalEmailError("Enter valid email id")
        } else {
            let temp = [...additionalEmails]
            temp.push(additionalEmail)
            setAdditionalEmails(temp)
            setAdditionalEmail('')
        }
    }

    let handleRemoveEmail = (indexToRemove) => {
        const filteredArr = additionalEmails.filter((_, index) => index !== indexToRemove);
        setAdditionalEmails(filteredArr)
    }

    let handleAddEmailChange = (e) => {
        setAdditionalEmailError('')
        let { value } = e.target
        setAdditionalEmail(value)
    }


    return (
        <div className="wrapper">
            <ToastContainer></ToastContainer>
            <Header />
            <div className="container-layout">
                <div className="heading-section">
                    <Container fluid>
                        <Row>
                            <Col xs="12">
                                <h2 className="main-title-h">User</h2>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="tabcontainer--users">
                    <Tab.Container id="left-tabs-example" className="role-tabe-user" defaultActiveKey="first" >
                        {/* <Nav variant="pills" className="tab-list-wgtItems mb-4" style={{ border: 'none' }}>
                            <Nav.Item className="items-wt-list" >
                                <Nav.Link eventKey="first" className="btn-tab-items">Role</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="items-wt-list">
                                <Nav.Link eventKey="second" className="btn-tab-items">Facility</Nav.Link>
                            </Nav.Item>
                        </Nav> */}

                        <Tab.Content>
                            <Tab.Pane eventKey="first">
                                <div className="items-roletab">
                                    <div className="text-end pb-3">
                                        {localStorage.role == 'Admin' && (
                                            <button type="button" className="btn btn-add-form" onClick={handleShowRole}>+ Assign Role</button>
                                        )}
                                    </div>
                                    <div className="table-wapper-area mb-5">
                                        <Table responsive className="table-chat-list mb-0">
                                            <thead className="thead-card thead-rolewap">
                                                <tr>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Email</th>
                                                    <th>Role</th>
                                                </tr>
                                            </thead>
                                            <tbody className="tbody-card">
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="4" className="text-center">
                                                            <div className="spinner-border text-primary" role="status" style={{ color: "#082e56" }}>
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : paginatedData.length ? (
                                                    paginatedData.map((val) => (
                                                        <tr key={val.email}>
                                                            <td>{val.first_name}</td>
                                                            <td>{val.last_name}</td>
                                                            <td>{val.email}</td>
                                                            <td>
                                                                <span className="role-txtspace">{val.role}</span>
                                                                {
                                                                    val.role ?
                                                                        <button onClick={() => handleShowRoleDelete(val.email)} className="btn p-0 border-0">
                                                                            <img src={crossIconRoll} alt="" />
                                                                        </button>
                                                                        :
                                                                        null
                                                                }

                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="4" className="text-center">No users found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                            <div className="pagination-heading mb-2">
                                                <span className="lbl-pagination">
                                                    Showing{" "}
                                                    <span className="txt-num-bold">
                                                        {Math.min(
                                                            (currentPage - 1) * itemsPerPage + 1,
                                                            userList.length
                                                        )}
                                                        –
                                                        {Math.min(
                                                            currentPage * itemsPerPage,
                                                            userList.length
                                                        )}
                                                    </span>
                                                    {" "}
                                                    of <span className="txt-num-bold">{userList.length}</span> Entries
                                                </span>
                                            </div>
                                            {/* 
                 
                    {/*Pagination .............................................................................*/}
                                            <>
                                                <div className="d-flex flex-wrap gap-2 align-items-center">
                                                    {/* First Page Button */}
                                                    <button
                                                        className={`btn btn-sm btn-paginate-web ${currentPage === 1 ? "disabled" : ""}`}
                                                        onClick={() => setCurrentPage(1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        First
                                                    </button>

                                                    {/* Previous Page Button */}
                                                    <button
                                                        className={`btn btn-sm btn-paginate-web ${currentPage === 1 ? "disabled" : ""}`}
                                                        onClick={() => setCurrentPage(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        Prev
                                                    </button>

                                                    {/* Page Numbers */}
                                                    {totalPages <= 6 ? (
                                                        // Show all pages if total pages is 6 or less
                                                        Array.from({ length: totalPages }, (_, i) => (
                                                            <button
                                                                key={i}
                                                                className={`btn btn-sm btn-paginate-web ${currentPage === i + 1 ? "btn-theme-btn" : ""
                                                                    }`}
                                                                onClick={() => setCurrentPage(i + 1)}
                                                            >
                                                                {i + 1}
                                                            </button>
                                                        ))
                                                    ) : (
                                                        // Show truncated pagination with ellipsis for more than 6 pages
                                                        <>
                                                            {/* Always show first page */}
                                                            <button
                                                                className={`btn btn-sm btn-paginate-web ${currentPage === 1 ? "btn-theme-btn" : ""
                                                                    }`}
                                                                onClick={() => setCurrentPage(1)}
                                                            >
                                                                1
                                                            </button>

                                                            {/* Show ellipsis after first page if current page is > 3 */}
                                                            {currentPage > 3 && <span className="px-2">...</span>}

                                                            {/* Show pages around current page */}
                                                            {[
                                                                currentPage - 1,
                                                                currentPage,
                                                                currentPage + 1,
                                                            ]
                                                                .filter(page => page > 1 && page < totalPages)
                                                                .map(page => (
                                                                    <button
                                                                        key={page}
                                                                        className={`btn btn-sm btn-paginate-web ${currentPage === page ? "btn-theme-btn" : ""
                                                                            }`}
                                                                        onClick={() => setCurrentPage(page)}
                                                                    >
                                                                        {page}
                                                                    </button>
                                                                ))}

                                                            {/* Show ellipsis before last page if current page is < totalPages - 2 */}
                                                            {currentPage < totalPages - 2 && <span className="px-2">...</span>}

                                                            {/* Always show last page */}
                                                            <button
                                                                className={`btn btn-sm btn-paginate-web ${currentPage === totalPages ? "btn-theme-btn" : ""
                                                                    }`}
                                                                onClick={() => setCurrentPage(totalPages)}
                                                            >
                                                                {totalPages}
                                                            </button>
                                                        </>
                                                    )}

                                                    {/* Next Page Button */}
                                                    <button
                                                        className={`btn btn-sm btn-paginate-web ${currentPage === totalPages ? "disabled" : ""
                                                            }`}
                                                        onClick={() => setCurrentPage(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Next
                                                    </button>

                                                    {/* Last Page Button */}
                                                    <button
                                                        className={`btn btn-sm btn-paginate-web ${currentPage === totalPages ? "disabled" : ""
                                                            }`}
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Last
                                                    </button>
                                                </div>
                                            </>
                                            {/*Pagination .............................................................................*/}

                                        </div>
                                    </div>

                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second">
                                <div className="items-roletab">
                                    <div className="text-end pb-3">
                                        <button type="button" className="btn btn-add-form" onClick={handleShowFacility}>+ Add Facility</button>
                                    </div>
                                    <div className="table-wapper-area mb-5">
                                        <Table responsive className="table-chat-list mb-0">
                                            <thead className="thead-card thead-rolewap">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Facility</th>
                                                    <th className="action-wdt text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="tbody-card">
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="3" className="text-center">
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : facilityList.length ? (
                                                    facilityList.map((val, i) => (
                                                        <tr key={val.value}>
                                                            <td>{i + 1}</td>
                                                            <td>{val.value}</td>
                                                            <td style={{ cursor: 'pointer' }} className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn p-0 border-0"
                                                                    onClick={() => handleShowDelete(val.value)}
                                                                >
                                                                    <img src={deleteIcon} alt="icon" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" className="text-center">No facilities found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </div>
            <Modal show={showRole} onHide={handleCloseRole} size="md" centered className="modal-role-bg">
                <Modal.Header closeButton className="border-0">
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                </Modal.Header>
                <Modal.Body className="p-5">
                    <Form>
                        <label className="role-label-txt">Assign Role</label>
                        <Form.Group className="mb-3 role-select-options position-relative" controlId="">
                            <SearchableDropdown
                                options={emailList}
                                placeholder="Select Email"
                                onSelect={(e) =>
                                    handleInputSelect(
                                        e,
                                        "email"
                                    )
                                }
                            />                            {
                                error.email ? <p style={{ fontSize: '12px', color: 'red' }} >{error.email}</p> : null
                            }

                        </Form.Group>
                        <Form.Group className="mb-3 role-select-options position-relative" controlId="">
                            <SearchableDropdown
                                options={RoleList}
                                placeholder="Select Role"
                                onSelect={(e) =>
                                    handleInputSelect(
                                        e,
                                        "role"
                                    )
                                }
                            />
                            <span className="icon-down-arrow-select"><img src={downIconWeb} /></span>
                            {
                                error.role ? <p style={{ fontSize: '12px', color: 'red' }} >{error.role}</p> : null
                            }                        </Form.Group>

                        <Form.Group className="submit-margin-top">
                            <button onClick={handleRoleSubmit} type="submit" className="btn submit-btn-role w-100">{roleLoading ? 'Loading...' : 'Submit'}</button>
                        </Form.Group>
                    </Form>
                </Modal.Body>
            </Modal>


            <Modal show={showFacility} onHide={handleCloseFacility} size="md" centered className="modal-role-bg">
                <Modal.Header closeButton className="border-0">
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                </Modal.Header>
                <Modal.Body className="p-5">
                    <Form>
                        <label className="role-label-txt">Add Facility</label>
                        <Form.Group className="mb-3 role-select-options position-relative" controlId="">
                            {/* <SearchableDropdown
                                options={inputOptionList}
                                placeholder="Choose your Facility"
                                onSelect={(e) =>
                                    handleInputSelect(
                                        e,
                                        "facility"
                                    )
                                }
                            /> */}
                            <input onChange={handleFcilityChange} name="selectedFacility" value={selectedFacility} type="text" placeholder="Enter facility" class="form-select-value form-control" />
                            <span className="icon-down-arrow-select"><img src={downIconWeb} /></span>
                            {
                                facilityError.error ? <p style={{ fontSize: '12px', color: 'red' }} >{'facility is required'}</p> : null
                            }
                        </Form.Group>
                        <Form.Group className="submit-margin-top">
                            <button onClick={handleFacilitySubmit} type="submit" className="btn submit-btn-role w-100">{facilityLoading ? 'Loading...' : 'Submit'}</button>
                        </Form.Group>
                    </Form>
                </Modal.Body>
            </Modal>



            <Modal show={showDelete} onHide={handleCloseDelete} centered>
                <Modal.Header closeButton className="border-0">
                </Modal.Header>
                <Modal.Body>
                    <div className="delete-modal-dsg text-center">
                        <div className="delete-icon-wp">
                            <span className="icon-block-dlt"><img src={deleteIconModal} alt="" /></span>
                        </div>
                        <h3 className="title-head-delete">Confirm Delete</h3>
                        <p className="delete-disc-txt">Are you sure you want to facility ? This action cannot be undone</p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center border-0 pb-5">
                    <button type="button" className="btn btn-cancel-dlt" onClick={handleCloseDelete}>Cancel</button>
                    <button onClick={handleDeleteFacility} type="button" className="btn btn-delete-dlt">{facilityLoading ? 'Deleting...' : 'Delete'}</button>
                </Modal.Footer>
            </Modal>

            <Modal show={showRoleDelete} onHide={handleCloseRoleDelete} centered>
                <Modal.Header closeButton className="border-0">
                </Modal.Header>
                <Modal.Body>
                    <div className="delete-modal-dsg text-center">
                        <div className="delete-icon-wp">
                            <span className="icon-block-dlt"><img src={deleteIconModal} alt="" /></span>
                        </div>
                        <h3 className="title-head-delete">Confirm Delete</h3>
                        <p className="delete-disc-txt">Are you sure you want to delete the role ? </p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center border-0 pb-5">
                    <button type="button" className="btn btn-cancel-dlt" onClick={handleCloseRoleDelete}>Cancel</button>
                    <button onClick={handleDeleteRole} type="button" className="btn btn-delete-dlt">{roleLoading ? 'Deleting...' : 'Delete'}</button>
                </Modal.Footer>
            </Modal>
            <MobileFooter></MobileFooter>


        </div>
    )
}
export default Users;